import React, { createContext, useEffect, useState } from 'react';
import authService from '../features/auth/auth-service';

export const AppContext = createContext({});

type AppStateProps = {
  children: JSX.Element;
};

export type AppState = {
  authenticated: boolean | undefined;
};

export const AppStateProvider = (props: AppStateProps): JSX.Element => {
  const [appState, setAppState] = useState<AppState>({ authenticated: undefined });

  useEffect(() => {
    setAppState({ authenticated: authService.isAuthed() });
  }, [setAppState]);

  return <AppContext.Provider value={appState}>{props.children}</AppContext.Provider>;
};
